(() => {
  angular.module('finance').component('panelLicenseInvoiceDetailTransactionViewComponent', {
    templateUrl: require('./panelLicenseTransactionView.component.html'),
    controller: PanelLicenseInvoiceDetailTransactionViewComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  PanelLicenseInvoiceDetailTransactionViewComponent.$inject = [];

  function PanelLicenseInvoiceDetailTransactionViewComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
